module.exports = __webpack_public_path__ + "img/0.0bcad3a8.png";